import { ArrowRight, LineChart } from 'lucide-react';
import { cn } from '@/lib/utils';
import { PaperStatusChip } from './PaperStatusChip';
import {
  PAPER_ICON_MICRO_CLASS,
  PAPER_ICON_SMALL_CLASS,
  PAPER_ICON_STROKE_WIDTH,
} from './paperShapes';

interface PaperMobileArtifactCardProps {
  title: string;
  onOpen: () => void;
  className?: string;
}

/**
 * Docked card that opens the artifact panel on mobile. Renders
 * directly below the chat top bar; tapping it calls `onOpen` which
 * flips the panel into its fullscreen takeover.
 */
export const PaperMobileArtifactCard = (props: PaperMobileArtifactCardProps) => (
  <div className={cn('shrink-0 px-[var(--chat-col-gutter)] py-2 pointer-events-none', props.className)}>
    <PaperStatusChip
      buttonProps={{
        onClick: props.onOpen,
        'aria-label': 'Show the Artifact Panel',
      }}
      className="pointer-events-auto"
      leading={
        <span className="text-[var(--fg-3)]">
          <LineChart className={PAPER_ICON_SMALL_CLASS} strokeWidth={PAPER_ICON_STROKE_WIDTH} />
        </span>
      }
      action={
        <span className="shrink-0 inline-flex items-center gap-[4px] text-[11px] text-[var(--fg-3)]">
          View
          <ArrowRight className={PAPER_ICON_MICRO_CLASS} strokeWidth={PAPER_ICON_STROKE_WIDTH} />
        </span>
      }
    >
      <span
        className="text-[var(--fg)]"
        style={{ fontFamily: 'var(--font-display)' }}
      >
        {props.title}
      </span>
    </PaperStatusChip>
  </div>
);
